import * as React from 'react';

import { useIntl } from 'bundles/page/lib/useIntl';
import KeyInformationDetailsItem from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationDetailsItem';
import { useDurationLabels } from 'bundles/unified-description-page-common/hooks/useDurationLabels';

import _t from 'i18n!nls/xdp';

type Props = {
  totalLearningMonths: number;
  learningHoursPerWeek: number;
};

export const KeyInformationSpecializationDurationAndSchedule = ({
  totalLearningMonths,
  learningHoursPerWeek,
}: Props) => {
  const intl = useIntl();

  const labels = useDurationLabels(totalLearningMonths * 40, true) ?? {
    title: _t('Flexible schedule'),
    subtitle: intl.formatMessage(
      _t(
        '{totalMonths} {totalMonths, plural, =1 {month} other {months}}, {totalHours} {totalHours, plural, =1 {hour} other {hours}} a week'
      ),
      {
        totalMonths: totalLearningMonths,
        totalHours: learningHoursPerWeek,
      }
    ),
  };

  return (
    <KeyInformationDetailsItem
      title={labels.title}
      subtitle={
        <>
          {labels.subtitle && <div>{labels.subtitle}</div>}
          <div>{_t('Learn at your own pace')}</div>
        </>
      }
    />
  );
};

export default KeyInformationSpecializationDurationAndSchedule;
